import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  informacastrecipientgroupList (context, opts) {
    if (!context.state.fetchingList) {
      context.commit('INFORMACASTRECIPIENTGROUP_FETCHING_LIST', true)
      return new Promise((resolve, reject) => {
        axios
          .get('/api/informacastrecipientgroup', { params: opts })
          .then(({ data }) => {
            context.commit('INFORMACASTRECIPIENTGROUP_LIST', data)
            resolve(data)
          })
          .catch((error) => reject(error))
          .finally(() => context.commit('INFORMACASTRECIPIENTGROUP_FETCHING_LIST', false))
      })
    }
  },
  // ==========================Socket Updates==============================
  informacastrecipientgroupCreated (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    axios
      .get(`/api/informacastrecipientgroup/${id}`, inputs)
      .then(({ data }) => {
        data.socketUpdate = true
        context.commit('INFORMACASTRECIPIENTGROUP_LIST_ADD', data)
      }).catch(() => {
      })
  },
  informacastrecipientgroupUpdated (context, opts) {
    const current = (context.rootState.Organization.current.id === opts.organization)
    if (opts.socket && current) {
      context.commit('INFORMACASTRECIPIENTGROUP_SOCKET_UPDATE', new Date())
    } else {
      const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
      const inputs = { }
      if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
        inputs.params = { }
        inputs.params.populate = opts.populate
      }
      const inList = context.state.list.find((i) => i.id === id)
      if (context.state.current.id === id || inList) {
        axios
          .get(`/api/informacastrecipientgroup/${id}`, inputs)
          .then(({ data }) => {
            if (data.id === context.state.current.id) {
              context.commit('INFORMACASTRECIPIENTGROUP_CURRENT', data)
            }
            if (inList) {
              context.commit('INFORMACASTRECIPIENTGROUP_LIST_UPDATE', data)
            }
          }).catch(() => {
          })
      }
    }
  },
  informacastrecipientgroupDestroyed (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    if (id === context.state.current.id) {
      context.commit('INFORMACASTRECIPIENTGROUP_CURRENT', null)
    }
    context.commit('INFORMACASTRECIPIENTGROUP_LIST_ITEM_REMOVE', opts)
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  informacastrecipientgroupDetail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/informacastrecipientgroup/${id}`, inputs)
        .then(({ data }) => {
          context.commit('INFORMACASTRECIPIENTGROUP_CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  informacastrecipientgroupUpdate (context, opts) {
    const updates = Object.assign({}, context.state.update)
    for (const key of Object.keys(updates)) {
      if ((updates[key] === null || updates[key] === context.state.current[key]) && key !== 'id') {
        delete updates[key]
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/informacastrecipientgroup/${context.state.current.id}`, updates)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  bulkUpdateInformacastRecipientGroups (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/informacastrecipientgroup/bulkupdate', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
